import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import AddressSelector from 'components/form/AddressSelector/container';

const LoadingWrapper = styled.div`
  padding: 0 ${gridSizes('M')};
`;

export { LoadingWrapper };
export default styled(AddressSelector)`
  width: 450px;

  .address-selector {
    &__no-results {
      font-size: 1.4rem;
      font-weight: 500;
      color: var(--grey500);
      margin: 0;
      padding: 1.6rem;
    }
    &__list {
      max-width: 100%;

      &-header {
        font-size: 1.4rem;
        font-weight: 500;
        color: var(--grey500);
        margin: 0;
        padding: 12px 16px;
      }
    }
  }

  .loading {
    padding: 12px 0;
    .loadWrap {
      flex-direction: row-reverse;
      .loadText {
        flex: none;
        margin-left: 2rem;
        font-size: 1.6rem;
      }
      .loader {
        margin: 0;
      }
    }
  }
`;
